var _CancellablePromise_cancellationTokenSource, _CancellablePromise_watcherPromise, _CancellablePromise_finallyEvent;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import CancellationTokenSource from './CancellationTokenSource';
import SingleInvokeEvent from '../Events/SingleInvokeEvent';
import noop from '../Utilities/noop';
export default class CancellablePromise {
    constructor(promise, cancellationToken) {
        _CancellablePromise_cancellationTokenSource.set(this, void 0);
        _CancellablePromise_watcherPromise.set(this, void 0);
        _CancellablePromise_finallyEvent.set(this, new SingleInvokeEvent());
        __classPrivateFieldSet(this, _CancellablePromise_cancellationTokenSource, new CancellationTokenSource(cancellationToken), "f");
        __classPrivateFieldSet(this, _CancellablePromise_watcherPromise, new Promise((resolve, reject) => {
            (async () => {
                try {
                    if (__classPrivateFieldGet(this, _CancellablePromise_cancellationTokenSource, "f").isCancellationRequested) {
                        return;
                    }
                    resolve(await promise);
                }
                catch (error) {
                    reject(error);
                }
                finally {
                    const cancelled = () => this.cancelled;
                    __classPrivateFieldGet(this, _CancellablePromise_finallyEvent, "f").invoke(this, {
                        get promise() {
                            return promise;
                        },
                        get cancelled() {
                            return cancelled();
                        }
                    });
                }
            })();
        }), "f");
    }
    get cancelled() {
        return __classPrivateFieldGet(this, _CancellablePromise_cancellationTokenSource, "f").isCancellationRequested;
    }
    cancel() {
        __classPrivateFieldGet(this, _CancellablePromise_cancellationTokenSource, "f").cancel();
        // as soon as wee call cancel finalise the promise
        __classPrivateFieldGet(this, _CancellablePromise_finallyEvent, "f").invoke(this, {
            promise: __classPrivateFieldGet(this, _CancellablePromise_watcherPromise, "f"),
            cancelled: this.cancelled
        });
    }
    then(onfulfilled, onrejected) {
        let promise;
        if (__classPrivateFieldGet(this, _CancellablePromise_cancellationTokenSource, "f").isCancellationRequested) {
            promise = new Promise(noop);
        }
        else {
            promise = __classPrivateFieldGet(this, _CancellablePromise_watcherPromise, "f").then(onfulfilled, onrejected);
        }
        const cancellable = new CancellablePromise(promise, __classPrivateFieldGet(this, _CancellablePromise_cancellationTokenSource, "f").token);
        this.finally((p, cancelled) => {
            if (cancelled) {
                cancellable.cancel();
            }
        });
        return cancellable;
    }
    catch(onrejected) {
        let promise;
        if (__classPrivateFieldGet(this, _CancellablePromise_cancellationTokenSource, "f")) {
            promise = new Promise(noop);
        }
        else {
            promise = __classPrivateFieldGet(this, _CancellablePromise_watcherPromise, "f").catch(onrejected);
        }
        const cancellable = new CancellablePromise(promise, __classPrivateFieldGet(this, _CancellablePromise_cancellationTokenSource, "f").token);
        this.finally((p, cancelled) => {
            if (cancelled) {
                cancellable.cancel();
            }
        });
        return cancellable;
    }
    finally(onfinally) {
        if (onfinally) {
            __classPrivateFieldGet(this, _CancellablePromise_finallyEvent, "f").addHandler((s, e) => onfinally(e.promise, e.cancelled));
        }
        return this;
    }
}
_CancellablePromise_cancellationTokenSource = new WeakMap(), _CancellablePromise_watcherPromise = new WeakMap(), _CancellablePromise_finallyEvent = new WeakMap();
